<div class="button-play">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.07 100.52">
    <g id="b51d25db-7ff3-4bbc-af2a-f4477547e463" data-name="Layer 2">
      <g id="ff6cb59a-77d0-4978-bf39-ce1564069307" data-name="button_play">
        <g id="ee010e4d-a7ee-40a3-abf8-3834dd12d757" data-name="button_play_down">
          <path
            d="M76.4,95.71c-1.8,2.39-14.67,4.12-31.65,4.13S12.84,98.48,13.1,95.48c.22-2.41,11.24-4.45,31.65-4.36,17,.07,33.82,1.71,31.65,4.59"
            style="opacity:0.15" />
          <path
            d="M89.53,50.17C87.1,74.06,69.77,91.33,46.9,91.41S3.94,77.8,4.3,47.9c.28-24,15.12-44.35,42.6-43.51,22.86.71,45.55,17,42.63,45.78"
            style="fill:#bf8d00" />
          <path
            d="M34.78,71.19a2.25,2.25,0,0,1-1.14-.31,2.28,2.28,0,0,1-1.13-1.95l-.35-42.05a2.27,2.27,0,0,1,3.42-2L72.35,46.45a2.27,2.27,0,0,1,0,3.94L35.9,70.9A2.34,2.34,0,0,1,34.78,71.19Z"
            style="fill:#f5f0df" />
        </g>
        <g id="f9aea8b6-e52a-49dc-8232-f8dd4d5c0bf0" data-name="button_play_up">
          <path
            d="M81.33,95.74c-2.09,2.77-17,4.77-36.6,4.78s-36.88-1.58-36.58-5c.24-2.78,13-5.14,36.58-5,19.62.08,39.1,2,36.6,5.3"
            style="opacity:0.15" />
          <path
            d="M93.79,50.4c-2.67,26.29-21.74,45.29-46.9,45.38S-.38,80.8,0,47.9C.32,21.47,16.65-.9,46.89,0,72,.8,97,18.77,93.79,50.4"
            style="fill:#ffbc00" />
          <path
            d="M33.55,73.53a2.55,2.55,0,0,1-1.25-.34,2.5,2.5,0,0,1-1.25-2.14l-.38-46.27a2.49,2.49,0,0,1,3.76-2.18L74.89,46.3a2.51,2.51,0,0,1,1.23,2.18,2.48,2.48,0,0,1-1.27,2.16L34.78,73.2A2.47,2.47,0,0,1,33.55,73.53Z"
            style="fill:#fff" />
        </g>
      </g>
    </g>
  </svg>
</div>
